import { createSelector } from 'reselect';

const selectGatewayLogs = (state: any) => state.gatewayLogs;


export const selectGatewayLogsCurrentItem = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.current);

export const selectGatewayLogsListItems = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.list);

export const selectGatewayLogsItemById = (itemId: any) =>
    createSelector(selectGatewayLogsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGatewayLogsCreatedItem = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.create);

export const selectGatewayLogsUpdatedItem = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.update);

export const selectGatewayLogsReadItem = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.read);

export const selectDeletedItem = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.delete);

export const selectGatewayLogsSearchedItems = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.search);

export const selectGatewayLogsItemsCount = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.count);

export const selectGatewayLogsItemsFilter = createSelector([selectGatewayLogs], (gatewayLogs) => gatewayLogs.filter);